import { gql } from "@apollo/client";

export const API_VERSION_QUERY = gql`
  query apiVersion {
    apiVersion {
      version
      date
    }
  }
`;

export const INSURANCE_SERVICE_VERSION_QUERY = gql`
  query insuranceServiceVersion {
    insuranceServiceVersion {
      version
      date
    }
  }
`;

export const INSURANCE_SERVICE_DETAILS = gql`
  query insuranceServiceDetails {
    insuranceServiceDetails
  }
`;

export const DATABASE_VERSION_QUERY = gql`
  query databaseVersion {
    databaseVersion
  }
`;

export const GQL_VERSION_QUERY = gql`
  query gqlVersion {
    gqlVersion {
      version
      date
    }
  }
`;

export const INSURANCE_DOCUMENTS_FOR_CHECK_QUERY = gql`
  query insuranceDocumentsForCheck($insuranceTypeCode: String!) {
    insuranceDocumentsForCheck(insuranceTypeCode: $insuranceTypeCode) {
      documentId
      documentNumber
      documentDate
    }
  }
`;

export const CROSS_CHECK_RESULT_STATUS = gql`
  {
    crossCheckResultStatus @client {
      data {
        documentId
        loading
      }
    }
  }
`;
